/* eslint-disable @typescript-eslint/no-explicit-any */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function goAndScroll (fn: any): (a: any) => void {
  return (a: any): void => {
    document.body.scrollIntoView({ block: 'start', behavior: 'smooth' })
    if (fn) fn(a)
  }
}
